export const getLanguageFlag = (langCode) => {
  switch (langCode) {
    case "en": return "🇬🇧";
    case "pt": return "🇵🇹";
    case "es": return "🇪🇸";
    default: return "";
  }
};
